import { axiosBaseInstance } from 'core/axios.config'

export const customerWalletDeposit = async (data: any) => {
	const v = await axiosBaseInstance.post(`/back_office/wallet/deposit`, data)
	return v.data
}

export const refundCacheFromWallet = async (data: any) => {
	const v = await axiosBaseInstance.post(`/back_office/wallet/refund_in_cache`, data)
	return v.data
}

export const getWalletOperations = async (params?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/wallet/operations/`, {
		params
	})
	return data
}

export const getBckOperations = async (params?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/processing/transactions`, {
		params
	})
	return data
}

export const getKaspiOperations = async (params?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/kaspi/operations`, {
		params
	})
	return data
}

export const getCashOperations = async (params?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/external/payments`, {
		params
	})
	return data
}

export const customerWalletOperationsId = async (operation_id?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/wallet/operations/${operation_id}`)
	return data
}

export const getCustomerNumber = async (phone?: any) => {
	const { data } = await axiosBaseInstance.get(`/back_office/customers/find-by-phone/${phone}`)
	return data
}

export const closeSession = async (data: any) => {
	const v = await axiosBaseInstance.put(`back_office/webkassa/close_session`, data)
	return v.data
}

export const sendPaymentFiscalReceipt = async ({ payment_method, payment_id }: any) => {
	const { data } = await axiosBaseInstance.post(
		`/back_office/payments/${payment_method}/${payment_id}/fiscal-receipt`
	)
	return data
}

export const cancelPaymentFiscalReceipt = async ({ payment_method, payment_id }: any) => {
	const { data } = await axiosBaseInstance.delete(
		`/back_office/payments/${payment_method}/${payment_id}/fiscal-receipt`
	)
	return data
}

export const runFiscalizationForDay = async ({ date }: { date: string }) => {
	const { data } = await axiosBaseInstance.post(`/back_office/webkassa/fiscalize-for-day`, { date })
	return data
}

export const runFiscalizationForDays = async (payload: { dates?: string[]; from?: string; to?: string }) => {
	const { data } = await axiosBaseInstance.post(`/back_office/webkassa/fiscalize-for-day`, payload)
	return data
}
